import { assetNotificationRoutines } from 'modules/admin/assetNotificationRoutines';
import { assetRoutines } from 'modules/asset/asset$';
import authRoutines from 'modules/auth/stream/routines';
import { courseRoutines } from 'modules/course/course$';
import { action$, collectRoutines, subscribeRoutine } from 'rxbeach';
import { Subject } from 'rxjs';

const error$ = new Subject<any>();

export default function startRoutines() {
  const routines = [
    assetRoutines,
    assetNotificationRoutines,
    authRoutines,
    courseRoutines,
  ];
  const routineSubscription = subscribeRoutine(
    action$,
    collectRoutines(...routines),
    error$
  );

  const errorSubscription = error$.subscribe((error) => console.error(error));

  if (import.meta.hot) {
    import.meta.hot.dispose(() => {
      routineSubscription.unsubscribe();
      errorSubscription.unsubscribe();
    });
  }
}
